// fixed PC location: a PC has no GPS and Windows guesses the position from Wi-Fi / internet (often outdated).
// With a saved PC location the browser position is replaced on desktop PCs and whenever the fix is coarser than 1 km.
const K = 'giss_pc_home';
export const getHome = () => { try { return JSON.parse(localStorage.getItem(K)); } catch { return null; } };
export const setHome = (h) => { if (h) localStorage.setItem(K, JSON.stringify(h)); else localStorage.removeItem(K); window.dispatchEvent(new Event('giss-pc-home')); };
export const isDesktop = () => !window.matchMedia?.('(pointer: coarse)').matches && !('ontouchstart' in window);
const active = () => { const h = getHome(); return h && !h.off ? h : null; };
const fake = (h) => ({ coords: { latitude: h.lat, longitude: h.lon, accuracy: 15, altitude: null, altitudeAccuracy: null, heading: null, speed: null }, timestamp: Date.now(), pcHome: true });
let warned = false;
const check = (p) => {
  const h = active();
  if (!getHome() && p.coords.accuracy > 1000 && !warned) { warned = true; window.dispatchEvent(new CustomEvent('giss-pc-home-warn', { detail: Math.round(p.coords.accuracy) })); }
  return h && p.coords.accuracy > 1000 ? fake(h) : p;
};

export function installPcHome() {
  const g = navigator.geolocation;
  if (!g || g.pcHome) return;
  const gc = g.getCurrentPosition.bind(g), wp = g.watchPosition.bind(g), cw = g.clearWatch.bind(g);
  let n = 0;
  g.getCurrentPosition = (ok, err, o) => {
    const h = active();
    if (h && isDesktop()) { setTimeout(() => ok(fake(h)), 0); return; }
    gc((p) => ok(check(p)), (e) => (h ? ok(fake(h)) : err?.(e)), o);
  };
  g.watchPosition = (ok, err, o) => {
    const h = active();
    if (h && isDesktop()) { setTimeout(() => ok(fake(h)), 0); n -= 1; return n; }
    return wp((p) => ok(check(p)), (e) => (h ? ok(fake(h)) : err?.(e)), o);
  };
  g.clearWatch = (id) => { if (id >= 0) cw(id); };
  g.pcHome = true;
}
